import React from "react";
import { addToCart, cejnToast } from "../api/api";

import { FaCloudDownloadAlt } from "react-icons/fa";
import { HiShoppingCart } from "react-icons/hi";

// redux
import { setCart } from "../redux/cartSlice";
import { useDispatch, useSelector } from "react-redux";

export default function ArticleButtons(props) {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cartData.cart);
  let match = cart.filter((x) => x.code === props.row.code)[0];

  const addItemToCart = async (code) => {
    let quantity = match ? match.quantity + 1 : 1;

    let data = await addToCart(code, quantity);
    if (!data?.status.success) {
      cejnToast(data.status.message ?? i18n.getString("cejnToast.errors.addItem"), "ERROR");
      return;
    }

    dispatch(setCart(data.items));
    cejnToast(data.status.message);
  };

  const baseClass = "c-parts-listing";

  return (
    <div className={`${baseClass + "__buttons"} ${props.disableColumn ? "disableColumn" : ""}`}>
      {(!!props.models || !!props.drawings) && (
        <div className={`${baseClass + "__inner-container"}`}>
          {/* download model files */}
          {props.models && (
            <span className={`${baseClass + "__download"}`} onClick={() => props.onDownload(props.models)}>
              <span>{i18n.getString("articlelisting.modelShort")}</span>
              <FaCloudDownloadAlt />
            </span>
          )}

          {/* download drawing files */}
          {props.drawings && (
            <span className={`${baseClass + "__download"}`} onClick={() => props.onDownload(props.drawings)}>
              <span>{i18n.getString("articlelisting.drawingShort")}</span>
              <FaCloudDownloadAlt />
            </span>
          )}
        </div>
      )}

      <div className={`${baseClass + "__inner-container"}`}>
        {/* add to cart */}
        <span
          className={`${baseClass + "__add-to-cart" + (match ? " in-cart" : "")}`}
          onClick={() => addItemToCart(props.row.code)}
        >
          <span>
            {i18n.getString("articlelisting.inquiryListButton")}
            {match && " (" + (match.quantity > 99 ? "99+" : match.quantity) + ")"}
          </span>
          <HiShoppingCart />
        </span>
      </div>
    </div>
  );
}
